import styled from 'styled-components';
import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxGroupProps } from 'antd/es/checkbox';
import CleanFeeCheckbox from './CleanFeeCheckbox';

const dates = [
  { label: 'MON', value: 2 },
  { label: 'TUE', value: 3 },
  { label: 'WED', value: 4 },
  { label: 'THR', value: 5 },
  { label: 'FRI', value: 6 },
  { label: 'SAT', value: 7 },
  { label: 'SUN', value: 1 },
];
type Props = {
  value?: number[]; // from 0 to 6
  onChange?: (value?: number[]) => void; // from 0 to 6
};

const DayOfWeek = ({ value, onChange }: Props) => {

  const onChangeCheckbox: CheckboxGroupProps['onChange'] = (checkedValues) => {
    const numbers = checkedValues.map((value) => Number(value));
    onChange?.(numbers);
  };

  return (
    <Container>
      <AntdCheckbox.Group value={value} onChange={onChangeCheckbox} className="checkbox-group" >
        {dates.map((o) => (
          <CleanFeeCheckbox value={o.value} key={o.value} >
            {o.label}
          </CleanFeeCheckbox>
        ))}
      </AntdCheckbox.Group>
    </Container>
  );
};

export default DayOfWeek;
const Container = styled.div`
  width: 100%;
  .checkbox-group {
    width: 100%;
  }
`;